module.exports = __webpack_public_path__ + "img/Delivery-disable.2136109e.svg";